// const baseUrl = "https://codeflarelimited.com/codeflare/mobile/"
// const baseUrl = "https://codefussion.tech/elearning/api/"
const baseUrl = "https://app.codeflarelimited.com/elearning/api/"

export { baseUrl }
